import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheese = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M10.09,14.86a1.9,1.9,0,0,1-1.9-1.79.49.49,0,0,1,0-.12,1.91,1.91,0,0,1,3.71-.62A1.84,1.84,0,0,1,12,13,1.9,1.9,0,0,1,10.09,14.86Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M22.5,9.9v8.4L10.89,20.62a1.55,1.55,0,0,0-1.54-1.27,1.58,1.58,0,0,0-1.58,1.57,1.48,1.48,0,0,0,0,.31h0L1.5,22.5V14.1L8,7a1.52,1.52,0,0,0,1.37.81,1.57,1.57,0,0,0,.64-3l3-3.29h1a8.37,8.37,0,0,1,8.4,8.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M17.82,19.24h0a1.86,1.86,0,0,0,.84-1.55,1.91,1.91,0,0,0-3.82,0,1.87,1.87,0,0,0,1.58,1.83"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 18.2,
			cy: 4.84,
			r: 1.91
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 22.5,
			y1: 9.14,
			x2: 11.69,
			y2: 11.59
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 8.88,
			y1: 12.23,
			x2: 1.5,
			y2: 13.91
		})
	]
});
const ForwardRef = forwardRef(SvgCheese);
export default ForwardRef;
